import CheckboxSelectItem from 'components/checkbox-select-item';
import FilterSidebar from 'components/filter-sidebar';
import Select from 'components/select';
import TextField from 'components/text-field';
import { Search } from 'lucide-react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import titleCase from 'utils/title-case';
import SelectSite from 'views/bluviu-nutrition/components/select-site';
import { useSelectedSite } from 'views/bluviu-nutrition/hooks/use-selected-site';
import { BluViuNutritionParams } from 'views/bluviu-nutrition/types/bluviu-nutrition-params.type';
import { ScenarioListItem } from '../types/scenario-list-item.type';
import { ScenarioState } from '../../../types/scenario-state.enum';
import CreateScenarioDialog from './create-scenario-dialog';

type Props = {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  selectedFilters: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>;
  scenarios: ScenarioListItem[];
};

const PAGE_NAME_ID = 'bluViuNutrition.listScenarios';

const FilterListScenarios: React.FC<Props> = ({ searchValue, setSearchValue, selectedFilters, setSelectedFilters, scenarios }) => {
  const params = useParams<BluViuNutritionParams>();
  const { selectedSiteId } = useSelectedSite();
  const history = useHistory();
  const intl = useIntl();

  return (
    <FilterSidebar
      clearFilters={() => {
        setSelectedFilters([]);
        setSearchValue('');
        history.push(`/bluviu-nutrition/${params.tab}`);
      }}
      showClearFilter={!!selectedSiteId || !!searchValue || !!selectedFilters.length}>
      <SelectSite />
      <Select
        multiple
        label={intl.formatMessage({ id: `${PAGE_NAME_ID}.filters.state.title` })}
        value={selectedFilters}
        onChange={(event) => {
          //   handlePagination(1);

          setSelectedFilters(event.target.value as string[]);
        }}>
        {Object.entries(ScenarioState)?.map((filter) => (
          <CheckboxSelectItem key={filter[1]} checked={selectedFilters.includes(filter[1])} value={filter[1]}>
            {titleCase(filter[1])}
          </CheckboxSelectItem>
        ))}
      </Select>
      <TextField
        label={intl.formatMessage({ id: `general.search` })}
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        endAdornment={<Search />}
      />
      <CreateScenarioDialog invalidNames={scenarios.map((scenario) => scenario.name)} />
    </FilterSidebar>
  );
};

export default React.memo(FilterListScenarios);
